module.exports = __webpack_public_path__ + "img/20230706112123.9801e8d3.png";